import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { trackButtonClick } from '../../firebaseConfig';
import { useAnalytics } from '../../lib/AnalyticsContext';

export function NavLinks() {
  const { trackUserAction } = useAnalytics();
  const navigate = useNavigate();
  const location = useLocation();
  const isLandingPage = location.pathname === '/';

  const scrollToSection = (id: string) => {
    // Track navigation link click
    trackButtonClick(`Navigation: ${id}`, 'Navbar');
    trackUserAction('navigation', {
      target_section: id,
      source: 'main_navbar'
    });

    if (isLandingPage) {
      // If already on landing page, just scroll to the section
      const element = document.getElementById(id);
      if (element) {
        const navbarHeight = 100; // Account for fixed navbar
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    } else {
      // If on another page, navigate to landing page with section hash
      navigate(`/#${id}`);
    }
  };

  const navigateToPricing = () => {
    // Track navigation to pricing
    trackButtonClick('Navigation: pricing', 'Navbar');
    trackUserAction('navigation', {
      target_page: 'pricing',
      source: 'main_navbar'
    });

    // Navigate to pricing page
    navigate('/pricing');
  };

  const navigateToAmbassadorProgram = () => {
    // Track navigation to ambassador program
    trackButtonClick('Navigation: ambassador-program', 'Navbar');
    trackUserAction('navigation', {
      target_page: 'ambassador-program',
      source: 'main_navbar'
    });

    // Navigate to ambassador program page
    navigate('/ambassador-program');
  };

  return (
    <div className="flex items-center gap-8">
      <button onClick={() => scrollToSection('features')} className="nav-link">Features</button>
      <button onClick={navigateToPricing} className="nav-link">Pricing</button>
      <button onClick={() => scrollToSection('how-it-works')} className="nav-link">How It Works</button>
      <button onClick={() => scrollToSection('testimonials')} className="nav-link">Testimonials</button>
      <button onClick={navigateToAmbassadorProgram} className="nav-link text-secondary-light dark:text-secondary-dark">Earn with MockTrail</button>
    </div>
  );
}